
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/premium/purchase",
      function () {
        return require("private-next-pages/premium/purchase.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/premium/purchase"])
      });
    }
  